/**
 * Timeline diagnostic pentru boot /m/{slug}.
 * Consolă mereu; panou on-screen dacă URL conține ?sj_debug=1
 */

export function hasPublicDebugParam() {
  try {
    return new URLSearchParams(window.location.search || '').get('sj_debug') === '1';
  } catch (_) {
    return false;
  }
}

export function hasPublicStaticTestParam() {
  try {
    const h = String(window.location.hostname || '');
    const nonProd = h === 'localhost' || h === '127.0.0.1' || h.startsWith('spressjoy-staging');
    return nonProd && new URLSearchParams(window.location.search || '').get('sj_static_test') === '1';
  } catch (_) {
    return false;
  }
}

let debugPanel = null;

export function publicBootTimeline(step, detail) {
  const d = detail !== undefined && detail !== null ? ` ${String(detail)}` : '';
  try {
    if (typeof console !== 'undefined' && console.info) {
      console.info('[SJ-Public]', step + d);
    }
  } catch (_) {}

  if (!hasPublicDebugParam()) return;
  try {
    if (!debugPanel) {
      debugPanel = document.createElement('div');
      debugPanel.id = 'sjPublicBootDebug';
      debugPanel.setAttribute(
        'style',
        'position:fixed;bottom:0;left:0;right:0;max-height:38vh;overflow:auto;' +
          'background:rgba(15,23,42,.95);color:#86efac;font:11px/1.45 ui-monospace,monospace;' +
          'z-index:2147483646;padding:10px 12px;border-top:1px solid #334155;'
      );
      var root = document.body || document.documentElement;
      if (root) root.appendChild(debugPanel);
    }
    const line = document.createElement('div');
    const t = new Date().toISOString().slice(11, 23);
    line.textContent = `[${t}] ${step}${d}`;
    debugPanel.appendChild(line);
    debugPanel.scrollTop = debugPanel.scrollHeight;
  } catch (_) {}
}
